export interface Breadcrumb {
  label: string;
  route: string;
}
